import { Carousel } from 'react-responsive-carousel'; // requires a loader
import React from 'react';
type Props = {
    images?: any[];
};
export default function MTinderInnerCarousel({ images }: Props) {
    return (
        <React.Fragment>
            {images && images.length > 0 && (
                <Carousel showThumbs={false} infiniteLoop autoPlay={false} showIndicators={false}>
                    {images?.map((f, i) => {
                        return (
                            <div key={i}>
                                <img src={f} alt="image" />
                            </div>
                        );
                    })}
                </Carousel>
            )}
        </React.Fragment>
    );
}
